export const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png']
